<template>
	<div>

		<v-row align="center">
      <v-col
        class="d-flex py-0"
        :cols="this.día ? 4 : 6"
      >
        <v-select
					v-model="datos.aaaa"
          :items="años"
          label="Año"
					:hide-details="hideDetails"
        ></v-select>
      </v-col>

      <v-col
        class="d-flex py-0"
        :cols="this.día ? 4 : 6"
      >
        <v-select
					v-model="datos.mm"
          :items="meses"
          label="Mes"
					:hide-details="hideDetails"
        ></v-select>
      </v-col>

      <v-col
				v-if="this.día"
        class="d-flex py-0"
        :cols="this.día ? 4 : 6"
      >
        <v-select
					v-model="datos.dd"
          :items="días"
          label="Día"
					:hide-details="hideDetails"
        ></v-select>
      </v-col>
		</v-row>

	</div>
</template>

<script>
export default {
	name: 'selector-de-fecha',
	data: () => ({
		añoActual: null,
		mesActual: null,
		díaActual: null,
		datos: {
			aaaa: '',
			mm: '',
			dd: ''
		},
		previo: ''
	}),
	props: ['value', 'hide-details', 'día'],
	mounted: function() {
		let ahora = new Date()
		this.añoActual = ahora.getFullYear()
		this.mesActual = ahora.getMonth() + 1
		this.díaActual = ahora.getDate()
	},
	computed: {
		años: function() {
			if (!this.añoActual) {
				return []
			}

			let aaaa = []
			let desde = 2020
			let i = this.añoActual
			while (i >= desde) {
				aaaa.push(i.toString())
				i--
			}

			return aaaa
		},
		meses: function() {
			let mm = [
				{value: '01', text: 'Enero'},
				{value: '02', text: 'Febrero'},
				{value: '03', text: 'Marzo'},
				{value: '04', text: 'Abril'},
				{value: '05', text: 'Mayo'},
				{value: '06', text: 'Junio'},
				{value: '07', text: 'Julio'},
				{value: '08', text: 'Agosto'},
				{value: '09', text: 'Septiembre'},
				{value: '10', text: 'Octubre'},
				{value: '11', text: 'Noviembre'},
				{value: '12', text: 'Diciembre'}
			]

			if (this.datos.aaaa && this.añoActual && this.datos.aaaa.toString() === this.añoActual.toString()) {
				mm = mm.slice(0, this.mesActual)
				if (this.datos.mm && Number(this.datos.mm) > this.mesActual) {
					this.datos.mm = ''
				}
			}

			return mm
		},
		días: function() {
			if (!this.día) {
				return []
			}

			let dd = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,26, 27, 28]

			let añoSeleccionado = Number(this.datos.aaaa)
			let mesSeleccionado = Number(this.datos.mm)
			let díaSeleccionado = Number(this.datos.dd)
			if ([4, 6, 9, 11].includes(mesSeleccionado)) {
				dd.push(29, 30)
			} else if ([1, 3, 5, 7, 8, 10, 12].includes(mesSeleccionado)) {
				dd.push(29, 30, 31)
			} else if (mesSeleccionado === 2 && añoSeleccionado > 0){
				if (añoSeleccionado % 4 === 0) {
					if (añoSeleccionado % 100 === 0) {
						if (añoSeleccionado % 400 === 0) {
							dd.push(29)
						}
					} else {
						dd.push(29)
					}
				}
			}

			if (this.datos.aaaa && this.datos.mm && añoSeleccionado === this.añoActual && mesSeleccionado === this.mesActual) {
				dd = dd.slice(0, this.díaActual)
				if (this.datos.dd && díaSeleccionado > this.díaActual) {
					this.datos.dd = ''
				}
			}

			return dd
		},
	},
	watch: {
		datos: {
			handler: function() {
				let v = this.datos.aaaa + '-' + this.datos.mm
				if (this.día) {
					let d = Number(this.datos.dd)
					let dd = d < 10 ? `0${d}` : d.toString()
					v += `-${dd}`
				}

				if (v.length === 7 || (v.length === 10 && this.datos.dd)) {
					this.$emit('input', v)
					this.previo = v
					return
				}

				if (this.previo) {
					this.$emit('input', '')
					this.previo = ''
				}
			},
			deep: true
		},
		value: {
			handler: function(v) {
				if (!v) {
					return
				}

				let pdzs = v.split('-')
				this.datos.aaaa = pdzs[0]
				this.datos.mm = pdzs[1]
				if (pdzs[2]) {
					this.datos.dd = Number(pdzs[2])
				}
			}
		}
	}
}
</script>